import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles, { createStyles } from '../../core/withStyles';
import { scrollable } from '../../mixins';
import ScrollableContext from './ScrollableContext';
import ScrollableVisibilitySensor from './ScrollableVisibilitySensor';
import ScrollableShadow from './ScrollableShadow';
import useVisibilityContainer from './useVisibilityContainer';
const styles = (_) => createStyles({
    root: {
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    scroll: Object.assign({ display: 'flex', flexDirection: 'column', flex: 1 }, scrollable()),
});
export const Scrollable = ({ className, shadowClassName, buffer, children, classes, }) => {
    const { containerRef, addRefToVisibilbityMap, removeRefFromVisibilbityMap } = useVisibilityContainer({ buffer });
    return (_jsx(ScrollableContext.Provider, Object.assign({ value: {
            scrollRef: containerRef,
            addRefToVisibilbityMap: addRefToVisibilbityMap,
            removeRefFromVisibilbityMap: removeRefFromVisibilbityMap,
        } }, { children: _jsxs("div", Object.assign({ className: cn(classes.root, className) }, { children: [_jsx(ScrollableShadow, { scrollRef: containerRef, position: "top", className: shadowClassName }), _jsx("div", Object.assign({ ref: containerRef, className: classes.scroll }, { children: typeof children === 'function'
                        ? children(containerRef)
                        : children })), _jsx(ScrollableShadow, { scrollRef: containerRef, position: "bottom", className: shadowClassName })] })) })));
};
export default Object.assign(withStyles(styles)(Scrollable), {
    VisibilitySensor: ScrollableVisibilitySensor,
});
//# sourceMappingURL=Scrollable.js.map